import { Component, OnInit, AfterViewInit, Inject, OnDestroy, Input } from '@angular/core';
import { PortalService } from '../services/portal.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { ISubscription } from 'rxjs/Subscription';
import { TopnavService } from '../header/topnav/topnav.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SharedService } from '../common/shared.service';

export interface DialogData {
 parameter;
}

/**
 * Author: Redza Rosli
 * 
 * Date Created: April 19th 2018
 * 
 * Description: Component class for Digital Service - /digitalservices
 **/
@Component({
  selector: 'gosg-digitalservices',
  templateUrl: './digitalservices.component.html',
  styleUrls: ['./digitalservices.component.css']
})

export class DigitalservicesComponent implements OnInit, AfterViewInit, OnDestroy {
  /*public hData = {
    "id": 18821,
    "title": "Jabatan Perikanan Malaysia",
    "description": "Jabatan Perikanan Malaysia (DOF)",
    "code": 4,
    "enabled": true,
    "language": {
      "languageId": 2,
      "languageCode": "ms",
      "languageName": "BAHASA MALAYSIA",
      "languageDescription": "Bahasa Malaysia",
      "isDefault": false
    },
    "agency": {
      "agencyId": 13,
      "agencyName": "Jabatan Pertanian Negeri Terengganu",
      "agencyCode": 13
    },
    "details": [
      "id": 20029,
      "title": "Semak Status Repot Polis",
      "description": "Semak Status Repot Polis",
      "url": "pdrm/police-report",
      "code": 51,
      "enabled": true,
      "citizen": false,
      "nonCitizen": false,
      "common": false,
      "form": false,
      "manual": null,
      "language": {
        "languageId": 2,
        "languageCode": "ms",
        "languageName": "BAHASA MALAYSIA",
        "languageDescription": "Bahasa Malaysia",
        "isDefault": false
      }  
    ]
  }; */

  dsData: any = [];
  contoh: any[];
  URL: any;
  href=[];
  languageId; //= this.languageId;
  mediaUrl: any;
  isLogin: boolean;
  @Input() state:string;
  @Input() validMyIdentity: any;

  lang; //= this.lang;
  private subscriptionLang: ISubscription;
  private subscriptionFontSize: ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };

  loading: boolean;
  alertData: any;
  alertEnText: string;
  alertMyText: string;
  public myflag: any;

  constructor(
    //private pageTitle: Title,
    private activatedRoute: ActivatedRoute, 
    private sharedService: SharedService,
    private portalservice: PortalService,
    private translate: TranslateService,
    private topnavservice: TopnavService,
    private toastr: ToastrService,
    @Inject(APP_CONFIG) private config: AppConfig,
    public dialog: MatDialog) {

    this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {
      const myLang = this.translate.currentLang;
      if (myLang === 'en') {
        this.lang = 'en';
        this.languageId = 1;
      }
      if (myLang === 'ms') {
        this.lang = 'ms';
        this.languageId = 2;
      }

      if (this.topnavservice.flagLang) {
        this.getDServices(this.languageId);
      }

      this.activatedRoute.queryParams.subscribe(params => {
        let lng = params['language'];
        if (lng && lng.toLowerCase() == 'my') {
          this.myflag = {language:"my"};
          this.translate.setDefaultLang('ms');
          this.translate.use('ms');
        } else {
          this.myflag = null;
        } 
      });

      setTimeout(()=>{
        this.translate.get('pageTitle.home').subscribe((title:string)=>{
          title = title + this.translate.instant('home.breadcrumb.digitalservices')
          this.sharedService.setTitle(title);
        }); 
      },500);

    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
    });

  }

  ngOnInit() {

    if (!this.languageId) {
      if (localStorage.getItem('langID')) {
        this.languageId = localStorage.getItem('langID');
      } else { 
        this.languageId = 1;
      }
    }
    
    this.mediaUrl = this.config.externalMediaURL + '/documents/';
    this.getDServices(this.languageId);
    this.getUserData();
    localStorage.setItem('idDservice', '');
    //window.scrollTo(0,0);

  }

  getTheme2() {
    if (localStorage.getItem('themeColor')) {
      return localStorage.getItem('themeColor') + ' 2px solid'; 
    } else { 
      return 'rgb(30, 190, 188) 2px solid';
    }
  }
  getTheme() {
    return localStorage.getItem('themeColor');
  }

  ngAfterViewInit() {
    
    this.translate.get('pageTitle.home').subscribe((title:string)=>{
      title = title + this.translate.instant('home.breadcrumb.digitalservices')
      this.sharedService.setTitleAndGtag(title);
    }); 

    this.getDServiceAlert();
    
    this.sharedService.loadFontSizeData();
   
  }

  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
  }

  getDServiceAlert() {
   
    this.sharedService.getLatestAnnouncement(this.languageId, 'dservice').
    subscribe(data => {
      this.alertData = data;
      if (this.alertData.statusCode == 'SUCCESS') {
     
        if (this.alertData.announcement) {
      
          if (this.languageId == 1) {
            this.alertEnText = this.alertData.announcement.announcementText;
            this.sharedService.showAnnouncement(this.alertEnText,''); 
          } else if (this.languageId == 2) {
            this.alertMyText = this.alertData.announcement.announcementText;
            this.sharedService.showAnnouncement(this.alertMyText,''); 
          }

          this.sharedService.isMaintenanceShown.next(true);

        }
      } 
    },
    Error => {
            
   });
  }

  getDServices(lang) {

    this.loading = true;

    this.portalservice.getDigitalServices(lang).subscribe(data => {

      this.dsData = data.list;
     
      console.log('dsData: ', this.dsData);
      
      this.loading = false;

    },
    error => {
      this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
      this.loading = false;

    });
  }

  getUrl(code,url,lang) {
    console.log(code,url,lang)
    this.loading = true;

    this.portalservice.getDigitalServices(lang).subscribe(data => {

      this.contoh =data.list;


    
         for (let i=0; i<this.contoh.length; i++) {
           
        this.URL = this.contoh[i].details;
        for (let x=0; x<this.URL.length; x++){
          if(code ==this.URL[x].code )
          this.href = this.URL[x].url;
          
        }

      }   

      this.openDialogPopup(this.href)
    
      console.log('contoh: ',this.URL);
      console.log('contoh: ',this.href);
      
      this.loading = false;
   

    },
    error => {
      this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
      this.loading = false;

    });
  
  }

  getUserData(){
    this.isLogin = false;
  }

  openDialog() {
    this.dialog.open(DigitalServiceDialog, {
    });
  }

  
  generateHiddenLink(dserviceCode, dUrl, agcCode, isInternal, common?, id?) {
    let url;
    if (isInternal) {
      url ='/portal/'+dUrl;
    } else {
      url = dUrl;
    }
    let finalUrl;
  
    if (isInternal) {
      url = url + '?service='+dserviceCode+'&agency='+agcCode; 
    }

    if (this.myflag) {
      if (url.match(/\?/)) {
        finalUrl = url + '&language=my';
      } else {
        finalUrl = url + '?language=my';
      }
    } else {
      finalUrl = url;
    }
    return finalUrl;
  }

  toTrack(dserviceCode, dUrl, agcCode, isInternal, common?, id?, transaction?) {
    let urlservice;
    let url = dUrl;
    // let code = dserviceCode;
    let finalUrl;
    localStorage.setItem('idDservice', id);
    if (isInternal) {
      if (url != "null"){
      url = url + '?service='+dserviceCode+'&agency='+agcCode; 
      }
    }

    if (this.myflag) {
      if (url.match(/\?/)) {
        finalUrl = url + '&language=my';
      } else {
        finalUrl = url + '?language=my';
      }
    } else {
      finalUrl = url;
    }
   

    if (this.languageId == 1){
      if (finalUrl != "null"){
        {
          window.open(finalUrl, '_blank'); 
          }
      } else {
        this.getUrl(dserviceCode,finalUrl,2)
        
      }
    }
    else if (this.languageId == 2) {
      if (finalUrl != "null"){
         {
          window.open(finalUrl, '_blank'); 
          }
      }else {
        this.getUrl(dserviceCode,finalUrl,1)
        // this.openDialogPopup( urlservice);
       // console.log("urlservice " +  urlservice)
        
      }  
    }

    console.log("Digital Service Portal");
    console.log("Transaction", transaction);
    if (transaction !== true) {
        this.portalservice.sendTrackingCount(dserviceCode,agcCode).subscribe(
          data =>{
            console.log('toTrack: sendTrackingCount');
        },
        error => {
          this.sharedService.showError(JSON.parse(error._body).statusDesc, '');

        });
    }

  } 

  openDialogPopup(param) {
   console.log('parameter: ',param);
    this.dialog.open(MessageCommonPopupDialog, {
      data: { parameter: param}
    });
  }
}

@Component({
  selector: 'digital-service-popup',
  templateUrl: './digital-service-popup.html',
})


export class DigitalServiceDialog {

  constructor(
    public dialogRef: MatDialogRef<DigitalServiceDialog>,
    private translate: TranslateService,
    private router: Router) {}

    onNoClick() {
      this.dialogRef.close();
    }

    goToRegister() {
      this.router.navigate(['/register']);
      this.dialogRef.close();
    }

    goToLogin() {
      // this.router.navigate(['./portal-protected/']);
      window.location.href = "../portal-protected/";
      this.dialogRef.close();
    }
    

}

@Component({
  selector: 'message-common-popup',
  templateUrl: './message-common-popup.html',
})


export class MessageCommonPopupDialog {

  langID: any;
  lang;

  constructor(
    private translate: TranslateService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<MessageCommonPopupDialog>){

      const myLang = translate.currentLang;

    if (myLang == 'en') {

        translate.get('HOME').subscribe((res: any) => {
            this.lang = 'en';
            this.langID = 1;
        });
    }

    if (myLang == 'ms') {

        translate.get('HOME').subscribe((res: any) => {
            this.lang = 'ms';
            this.langID = 2;
        });
    }
  }

    onNoClick() {
      this.dialogRef.close();
      window.open(this.data.parameter, '_blank');
    }
    

}


// WEBPACK FOOTER //
// ./src/app/digitalservices/digitalservices.component.ts